import LeetCodeArchitecture from '../assets/leetcodeArchitecture2.png';
import spiderman from '../assets/semantic-web-blog-asset.png';

const blogData = [
  {
    id: 1,
    title: "LeetCode EXPOSED : How It REALLY Works Behind the Scenes! 🔥",
    description: "Dive into LeetCode's back-end architecture and code assessment processes that drive its speed and security.",
    link: "https://kartikbindra.hashnode.dev/leetcode-exposed-how-it-really-works-behind-the-scenes",
    image: LeetCodeArchitecture,
  },
  {
    id: 2,
    title: "What if I told you your 'next-gen AI Stack' is as old as Google?",
    description: "Exposing RAG Context Engineering as the DOPPLEGANGER of Semantic Web propose by Sir Tim Berners-Lee.",
    link: "https://open.substack.com/pub/kartikbindra/p/what-if-i-told-you-your-next-gen?r=3pux17&utm_campaign=post&utm_medium=web",
    image: spiderman,
  },
];

export default blogData;
